/*
 * File: OnlineUsersWidget.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 17, 2025 at 10:37 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	display: inline-flex;
	flex-direction: column;
	align-items: start;

	& > p {
		min-width: 40px;
		font-size: 1.0rem !important;

		&.shimmer-element {
			position: relative;
			top: -3px;
		}
	}
`;

export const OnlineStatus = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	margin-top: -5px;

	p {
		color: ${({ theme }) => theme.secondaryText};
		font-size: 0.9rem !important;
	}
`;

export const OnlineIndicator = styled.div`
	width: 9px;
	height: 9px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.statusSuccessBase};
`;
